import { render, staticRenderFns } from "./NetellerFailed.vue?vue&type=template&id=5624476c&"
import script from "./NetellerFailed.vue?vue&type=script&lang=js&"
export * from "./NetellerFailed.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports